import React from "react";

/** Green banner shown on the login page when a family invite is active. */
export function InviteBanner({ invitePreview, onRemove }) {
    return (
        <div
            data-testid="login-invite-banner"
            className="mb-5 rounded-2xl border border-[#1B5E20]/30 bg-[#E8F5E9] px-5 py-4"
        >
            <div className="text-[11px] uppercase tracking-[0.16em] text-[#1B5E20] font-semibold">
                Family Invitation
            </div>
            <p className="mt-1 text-[14.5px] text-[#1F1F1F]">
                You've been invited
                {invitePreview.invited_by ? ` by ${invitePreview.invited_by}` : ""} to join your
                family's Family Repository as{" "}
                <span className="font-semibold">{invitePreview.person_name}</span>.
            </p>
            <button
                type="button"
                data-testid="login-invite-remove"
                onClick={onRemove}
                className="mt-1.5 text-[12.5px] text-[#777] underline"
            >
                Not you? Remove invite
            </button>
        </div>
    );
}
